module.exports = __webpack_public_path__ + "img/icon9.13c570d0.svg";